import dayjs from 'dayjs';

import { weeklyPlannerDayDisplayFormat } from '~libs/dayjs';

import { Column, Row } from '~components/table-view-v3';
import WorkerFocusAction from '~weekly-planner/components/WorkerFocusAction';

const getAwardAlertsColumns = (): Column[] => [
  {
    id: 'date',
    header: 'Day',
    type: 'text',
    classNames: {
      cell: 'ml-2',
    },
    deriveValue: ({ date }) => (date ? dayjs(date).format(weeklyPlannerDayDisplayFormat) : '-'),
  },
  {
    id: 'user.full_name',
    header: 'Worker',
    type: 'text',
    deriveValue: (row) => row.user?.full_name ?? '',
  },
  {
    id: 'message',
    header: 'Alert',
    type: 'text',
  },
  {
    id: 'actions',
    header: '',
    type: 'custom',
    component: WorkerFocusAction,
    componentProps: (row: Row) => ({ userId: row.user?.id }),
  },
];

export default getAwardAlertsColumns;
